import { CDN_URL_1 } from "@/config";
export const backgrounImgUrl = `${CDN_URL_1}/ksForm`
